@import 'styles/mixins';
@import 'styles/blaze/mixins';

/* stylelint-disable css-modules/no-global-scoped-selector */
:root {
  --carousel-duration: 320ms;
  --carousel-ease: cubic-bezier(0.2, 0.8, 0.2, 1);
}
/* stylelint-enable css-modules/no-global-scoped-selector */

.fullScreenPreview {
  @include blur(15px);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(243, 245, 246, 0.93);
  z-index: 1000;
}

.body {
  @include hide-scrollbar;
  position: absolute;
  top: 62px;
  left: 0;
  right: 0;
  bottom: 0;
  display: grid;
  grid-template-columns: 330px 1fr auto;
  gap: 10px;
  overflow: auto;

  @media (max-width: $inch13Width) {
    grid-template-columns: 1fr auto;
  }

  &[data-chat-open='false'] {
    grid-template-columns: 0 1fr auto;
  }

  &[data-nextgen-chat='on'] {
    grid-template-columns: 360px 1fr auto;

    @media (max-width: $inch13Width) {
      grid-template-columns: 1fr auto;
    }
  }

  &[data-nextgen-chat='on'][data-chat-open='false'] {
    grid-template-columns: 0 1fr auto;
  }

  [data-autopilot-system-redesign='on'] & {
    top: 60px;
    gap: 0;
    background: #fafafa;
  }
}

.leftColumn {
  padding: 10px;

  [data-autopilot-system-redesign='on'] & {
    padding: 0;
  }

  @media (max-width: $inch13Width) {
    .body[data-chat-open='true'] & {
      display: none;
    }
  }
}

.chatContainer {
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  width: 330px;
  background: transparent;
  transform: translateX(-100%);
  opacity: 0;
  transition: none !important;

  &.isVisible {
    background: var(--light-80);
    transform: translateX(0);
    opacity: 1;

    @include container-shadow;

    [data-autopilot-system-redesign='on'] & {
      background: transparent;
      box-shadow: none;
    }
  }

  &:not(.isVisible) {
    background: transparent;
    transform: translateX(-100%);
    opacity: 0;
    box-shadow: none;
  }

  &[data-nextgen-chat='on'] {
    width: 360px;
    --chat-width: 360px;
    border-radius: 0;
  }
}

.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.centerColumn {
  height: 100%;
  position: relative;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;

  [data-autopilot-system-redesign='on'] & {
    background: #fafafa;
  }

  .body[data-chat-open='false'] & {
    transform: translateX(calc(140px));

    &.isUnauthedUser {
      transform: translateX(0);
    }

    @media (max-width: $inch15Width) {
      transform: translateX(0);
    }
  }
}

.rightColumn {
  @include hide-scrollbar;
  position: relative;
  display: flex;
  align-items: start;
  padding-right: 10px;
  padding-top: 10px;
  justify-content: flex-end;
  overflow-y: auto;

  [data-autopilot-system-redesign='on'] & {
    padding-right: 0;
    padding-top: 0;
    background: var(--light-60);
    border-left: 1px solid var(--dark-4);
  }
}

.toolbarMount {
  position: sticky;
  top: 10px;
  right: 10px;
  margin-left: auto;
}

.carousel {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  &.isArticlePreview {
    max-width: 835px;
  }

  .slide {
    position: absolute;
    inset: 0;
    display: block;
    transition: none !important;
  }

  .carouselItem {
    @include hide-scrollbar;
    position: absolute;
    transition: none !important;
  }

  .current {
    transform: translate3d(0, 0, 0);
  }
}

.carousel[data-phase='animate'] .slide[data-role='incoming'],
.carousel[data-phase='animate'] .slide[data-role='outgoing'] {
  transition: none !important;
}

.slide.hidden {
  pointer-events: none;
  position: absolute;
  top: -9999px;
  left: -9999px;
  overflow: hidden;
  z-index: -1;
  visibility: hidden;

  .carouselItem {
    opacity: 0;
    visibility: hidden;
    overflow: hidden;
  }
}

.carousel[data-direction='right'][data-phase='prepare'] {
  .slide[data-role='outgoing'] {
    transform: translate3d(0%, 0, 0);
  }
  .slide[data-role='incoming'] {
    transform: translate3d(100%, 0, 0);
  }
}
.carousel[data-direction='right'][data-phase='animate'] {
  .slide[data-role='outgoing'] {
    transform: translate3d(-100%, 0, 0);
  }
  .slide[data-role='incoming'] {
    transform: translate3d(0%, 0, 0);
  }
}

.carousel[data-direction='left'][data-phase='prepare'] {
  .slide[data-role='outgoing'] {
    transform: translate3d(0%, 0, 0);
  }
  .slide[data-role='incoming'] {
    transform: translate3d(-100%, 0, 0);
  }
}
.carousel[data-direction='left'][data-phase='animate'] {
  .slide[data-role='outgoing'] {
    transform: translate3d(100%, 0, 0);
  }
  .slide[data-role='incoming'] {
    transform: translate3d(0%, 0, 0);
  }
}

.carousel[data-phase='animate'] .slide[data-role='outgoing'] .carouselItem {
  opacity: 1;
  transition: none !important;
}
.carousel[data-phase='prepare'] .slide[data-role='incoming'] .carouselItem {
  opacity: 1;
}
.carousel[data-phase='animate'] .slide[data-role='incoming'] .carouselItem {
  opacity: 1;
  transition: none !important;
}

@media (prefers-reduced-motion: reduce) {
  .carousel[data-phase='animate'] .slide,
  .carousel[data-phase='animate'] .slide .carouselItem {
    transition: none !important;
  }

  .chatContainer {
    transition: none !important;

    &.isVisible {
      transform: translateX(0);
      opacity: 1;
    }
  }
}

.contentRating {
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 16px;
  left: 0;
  right: 0;
  z-index: 2;
}

.designPreviewContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: var(--post-max-width);
  aspect-ratio: var(--aspect-ratio);
  width: var(--post-max-width);
  border-radius: 20px;
  position: relative;
  min-width: calc(100% - 500px);
  border: none;
  box-shadow: none;
}

.hasToolbar {
  min-height: calc(100vh - 245px);
}

.nextFileContainer {
  right: 0;
  scale: 0.4;
  opacity: 0.4;
  transform-origin: right;
  transform: translateX(calc(100% - 60px));
  display: flex;
  align-items: center;
  justify-content: center;
  width: max-content;
}

.centerFileContainer {
  scale: 1;
  opacity: 1;
  right: 50%;
  transform-origin: center;
  transform: translateX(50%);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  &.isCenterFilePortraitPreview {
    height: 100%;
    overflow: auto;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;

    &.hasRatingOverlay {
      padding-bottom: 90px;
    }

    &.overflowing,
    &.isArticlePreview {
      align-items: flex-start;
      padding-top: 40px;
    }

    &.isBlogPostPreview,
    &.isNewsletterPreview {
      align-items: flex-start;
      padding-top: 40px;
      padding-left: 0;
      padding-right: 0;
    }
  }
}

.previewContentWrapper {
  position: relative;
  display: flex;
  align-items: center;
  min-width: 0;
}

.previousFileContainer {
  right: 100%;
  transform: translateX(60px);
  transform-origin: right;
  scale: 0.4;
  opacity: 0.4;
  display: flex;
  align-items: center;
  justify-content: center;
  width: max-content;
}

.isSideFileArticlePreview {
  height: 100%;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  opacity: 0.75;
}

.multiPlatformPreview {
  position: relative;
  width: 100%;
  min-height: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.platformPreviewOverlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease-in-out;
}

.activePlatform {
  opacity: 1;
  z-index: 10;
  position: static;
  width: 100%;
  height: auto;
  border: 1px solid var(--dark-8);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0px 20px 80px 0px rgba(0, 0, 0, 0.1);
}

.inactivePlatform {
  opacity: 0;
  z-index: 1;
  pointer-events: none;
}
